interface SchemeWithCheckmarkShieldSVGProps {
  color: string;
  style: React.CSSProperties;
}

const SchemeWithCheckmarkShieldSVG = ({
  color,
  style,
}: SchemeWithCheckmarkShieldSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
  >
    <g clipPath="url(#clip0_771_16146)">
      <path
        d="M22.4136 13.1739L24.9008 15.3869L28.4851 10.9988"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M34.2443 3.27218C28.6551 3.93418 25.1749 0.71875 25.1749 0.71875C25.1749 0.71875 21.7041 3.93418 16.1055 3.27218C16.1055 3.27218 14.3559 18.0821 25.1749 21.2786C35.9844 18.0821 34.2443 3.27218 34.2443 3.27218Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.0015 40.8645V44.7419"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.4404 33.9229H48.5628C49.2626 33.9229 49.8206 34.4903 49.8206 35.1807V39.5971C49.8206 40.297 49.2532 40.855 48.5628 40.855H29.4404C28.7406 40.855 28.1826 40.2875 28.1826 39.5971V35.1807C28.1826 34.4808 28.75 33.9229 29.4404 33.9229Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.0015 37.3936H45.0257"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.5035 37.3936C47.5035 37.2612 47.39 37.1477 47.2576 37.1477C47.1252 37.1477 47.0117 37.2612 47.0117 37.3936C47.0117 37.526 47.1252 37.6395 47.2576 37.6395C47.39 37.6395 47.5035 37.526 47.5035 37.3936Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.5625 22.8013H29.4307C28.736 22.8013 28.1729 23.3644 28.1729 24.0591V28.485C28.1729 29.1797 28.736 29.7428 29.4307 29.7428H48.5625C49.2571 29.7428 49.8203 29.1797 49.8203 28.485V24.0591C49.8203 23.3644 49.2571 22.8013 48.5625 22.8013Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.0015 26.272H45.0257"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.5035 26.272C47.5035 26.1396 47.39 26.0261 47.2576 26.0261C47.1252 26.0261 47.0117 26.1396 47.0117 26.272C47.0117 26.4044 47.1252 26.5179 47.2576 26.5179C47.39 26.5179 47.5035 26.4044 47.5035 26.272Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M35.7386 11.6702H48.5625C49.2624 11.6702 49.8204 12.2376 49.8204 12.928V17.3445C49.8204 18.0443 49.2529 18.6023 48.5625 18.6023H32.561"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.0015 15.1409H45.0257"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.5035 15.1409C47.5035 15.0085 47.39 14.895 47.2576 14.895C47.1252 14.895 47.0117 15.0085 47.0117 15.1409C47.0117 15.2733 47.1252 15.3868 47.2576 15.3868C47.39 15.3868 47.5035 15.2733 47.5035 15.1409Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.3486 40.8645V44.7419"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.713 44.7419H8.98438V49.4705H13.713V44.7419Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.3658 44.7419H36.6372V49.4705H41.3658V44.7419Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1.78759 33.9229H20.91C21.6098 33.9229 22.1678 34.4903 22.1678 35.1807V39.5971C22.1678 40.297 21.6003 40.855 20.91 40.855H1.78759C1.08776 40.855 0.529785 40.2875 0.529785 39.5971V35.1807C0.529785 34.4808 1.09721 33.9229 1.78759 33.9229Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.3486 37.3936H17.3728"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.8604 37.3936C19.8604 37.2612 19.7469 37.1477 19.6145 37.1477C19.4821 37.1477 19.3687 37.2612 19.3687 37.3936C19.3687 37.526 19.4821 37.6395 19.6145 37.6395C19.7469 37.6395 19.8604 37.526 19.8604 37.3936Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.9194 22.8013H1.78759C1.09292 22.8013 0.529785 23.3644 0.529785 24.0591V28.485C0.529785 29.1797 1.09292 29.7428 1.78759 29.7428H20.9194C21.6141 29.7428 22.1772 29.1797 22.1772 28.485V24.0591C22.1772 23.3644 21.6141 22.8013 20.9194 22.8013Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.3486 26.272H17.3728"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.8604 26.272C19.8604 26.1396 19.7469 26.0261 19.6145 26.0261C19.4821 26.0261 19.3687 26.1396 19.3687 26.272C19.3687 26.4044 19.4821 26.5179 19.6145 26.5179C19.7469 26.5179 19.8604 26.4044 19.8604 26.272Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.7891 18.612H1.78759C1.08776 18.612 0.529785 18.0446 0.529785 17.3542V12.9377C0.529785 12.2379 1.09721 11.6799 1.78759 11.6799H14.3656"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.3486 15.1411H15.7651"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.0015 33.9229V29.7334"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.0015 22.8013V18.6118"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.3486 33.9229V29.7334"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.3486 22.8013V18.6118"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M0.529785 47.1062H8.98448"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.7129 47.1062H36.637"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.3657 47.1062H49.8204"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_771_16146">
        <rect width="50.3499" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default SchemeWithCheckmarkShieldSVG;
